const SETTINGS = {
  ethereum: {
    explorerUrl: ETH_NETWORK_EXPLORER_URL,
  },

  tokens: {
    USDC: {
      scale: 2,
    },
  },

  fiat: {
    USD: {
      scale: 2,
    },
  },
};

export default SETTINGS;
